export type VoucherStatusType = "success"|"only-abo"|"not-applicable"|"max-redemption"|"not-found";

export interface PriceInformation {
    startPrice: number,
    totalPrice: number,
    discountPrice: number,
    discountPercentage: number,
    voucherStatus: VoucherStatusType,
    voucherTag: string,
    voucherCode?: string;
}

export const emptyPriceInformation: PriceInformation = {
    startPrice: 0,
    totalPrice: 0,
    discountPrice: 0,
    discountPercentage: 0,
    voucherStatus: null,
    voucherTag: null
}

export interface CourseType {
    id: string;
    title: string;
    uuid: string;
    slug: string;
    price: number;
    priceInstead: number;
    state: string;

    cook: {
        name: string;
    }
}

export type ProductTagType = "basic"|"premium"|"duo"|"family"|"basic-6m";

export interface ProductType {
    id: number;
    tag: ProductTagType;
    price: number;
    priceBefore: number;
    upgradeGiftcardValue: number;
}
